class ColorVariants extends HTMLElement {
  constructor() {
    super();
    this.styleCode = this.dataset.style;
    this.normalSwatchContainer = this.querySelector('[data-normal-swatches]');
    this.limitedSwatchContainer = this.querySelector('[data-limited-swatches]');
    this.query = `SwatchStyle:${this.styleCode}`;
    this.producJson = document.querySelector('[data-product-json]');
    this.productMainInfo = document.querySelector('.product-main__info');
    this.currentColor = this.dataset.colorName;
    this.init();
  }

  renderSwatches(data) {
    data.results.forEach((product, index, array) => {
      const swatch = document.createElement('div');
      swatch.classList.add('color-variants__swatch-image-wrapper');

      let color = null;
      let needsBorder = null;

      product.color_name ? (color = product.color_name) : null;

      product.needs_border ? (needsBorder = product.needs_border) : null;
      product.compare_at_price ? swatch.classList.add('last-order') : null;

      if (color) {
        swatch.innerHTML = `
        <a href="${product.url}" class="flex cursor-pointer items-center justify-center rounded-full aspect-square w-6${
          color == this.currentColor ? ' border' : ''
        }">
          <img class="rounded-full aspect-square w-[18px]${needsBorder ? ' border border-gray' : ''}" src="${
            product.swatch_image
          }" alt="${color}">
        </a>
        `;
        let isLimited = false;

        product.tags.includes('Limited Edition') ? (isLimited = true) : null;

        if (isLimited && this.limitedSwatchContainer) {
          this.limitedSwatchContainer.appendChild(swatch);
        } else if (!isLimited && this.normalSwatchContainer) {
          this.normalSwatchContainer.appendChild(swatch);
        }
      }
    });
  }

  init() {
    fetch(`/search?type=product&q='${this.query}'&view=json-data`).then((response) => {
      response.json().then((data) => {
        this.renderSwatches(data);
      });
    });
  }
}

if (!customElements.get('color-variants')) {
  customElements.define('color-variants', ColorVariants);
}
